import dayjs from 'dayjs';

import { useForm } from '@mantine/form';

import { selectPersonId } from '@/store/user-process/user-selectors.ts';

import { TODAY } from '@/shared/constant/app';
import useAppStore from '@/shared/store/app.store.ts';
import { TDateRange } from '@/shared/types/app.types';
import { IGuest } from '@/shared/types/booking.types';
import { BookingType } from '@/shared/types/bookingObjects.types';

import { getNearestDate } from '@/utils/date';

import { useAppSelector } from '@/hooks';

export type TMeetingRoomForm = {
	booking_object_id?: number | null;
	client_id: number | undefined;
	date: TDateRange;
	kind: BookingType;
	additional_clients_id: number[];
	guests: IGuest[] | [];
	service_required?: boolean;
	initiator_id: number | undefined;
	appointment_subject: string;
	appointment_body: string;
	show_auto: boolean;
};

export const useMeetingRoomForm = () => {
	const { date } = useAppStore();
	const personId = useAppSelector(selectPersonId);

	const form = useForm<TMeetingRoomForm>({
		initialValues: {
			date: [
				(dayjs(date[0]).isToday() ? getNearestDate(TODAY) : dayjs(date[0])).toDate(),
				(dayjs(date[1]).isAfter(TODAY)
					? dayjs(date[1])
					: getNearestDate(TODAY).endOf('day')
				).toDate(),
			],
			client_id: personId,
			booking_object_id: null,
			kind: 'meeting_room',
			additional_clients_id: [],
			initiator_id: personId,
			guests: [],
			appointment_subject: '',
			appointment_body: '',
			show_auto: false,
		},
		transformValues: (values) => ({
			...values,
			guests: values.guests.map((g) =>
				g.car_number ? { ...g, car_number: String(g.car_number).toUpperCase() } : g,
			),
		}),
		validate: {
			date: (value) => (!value ? 'Invalid date' : null),
			client_id: (value) => (!value ? 'Invalid client_id' : null),
			booking_object_id: (value) => (!value ? 'Invalid booking_object_id' : null),
		},
	});

	return form;
};
